"use client";

/**
 * Lazy-loaded components for better performance
 *
 * These components use Framer Motion or other heavy dependencies.
 * Import from this file when the component is:
 * - Below the fold (not immediately visible)
 * - Shown conditionally (modals, dropdowns)
 * - Not critical for SEO
 *
 * Per Vercel Best Practices: bundle-dynamic-imports
 *
 * @example
 * import { LazyModal, LazyCircularTestimonyCarousel } from '@jesus-central-church/ui/src/components/lazy';
 */

import dynamic from "next/dynamic";

// Modal - only loads when opened (uses Framer Motion AnimatePresence)
export const LazyModal = dynamic(
  () => import("./modal").then((mod) => mod.Modal),
  { ssr: false }
);

// CircularTestimonyCarousel - heavy Framer Motion animations
// Use for below-the-fold testimonial sections
export const LazyCircularTestimonyCarousel = dynamic(
  () =>
    import("./church/circular-testimony-carousel").then(
      (mod) => mod.CircularTestimonyCarousel
    ),
  { ssr: false }
);

// TestimonyCarousel - uses react-slick carousel
export const LazyTestimonyCarousel = dynamic(
  () =>
    import("./church/testimony-carousel").then((mod) => mod.TestimonyCarousel),
  { ssr: false }
);

// YouTubeLiveAlert - polls for live status, not needed for initial render
export const LazyYouTubeLiveAlert = dynamic(
  () => import("./youtube-live-alert").then((mod) => mod.YouTubeLiveAlert),
  { ssr: false }
);

// Note: Component prop types are defined inline in their files
// If you need type-safe props, import the component directly and use ComponentProps<typeof Component>
